import { MatDialogRef } from "@angular/material";
import { Component, OnInit } from '@angular/core';
import { ProductStatsService } from "../../services/productStats.service";
import { ProductStats } from "../../models/ProductStats";
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-productStatsTransactionModal',
  templateUrl: '../templates/productStatsModal.component.html'
})
export class ProductStatsModalComponent implements OnInit {
  data: ProductStats[];
  total: {
    monthly: number,
    quarterly: number,
    yearly: number,
    all: number,
  };

  today: moment.moment;
  dateUtc: moment.moment;

  constructor(
    private dialogRef: MatDialogRef<ProductStatsModalComponent>,
    private productStatsService: ProductStatsService) {

  }

  ngOnInit() {
    moment.tz.setDefault("UTC");
    this.today = moment().set({ hours: 23, minute: 59, second: 59, millisecond: 999 });
    this.dateUtc = this.today;

    this.productStatsService.Get(this.today)
    .subscribe(x => {
      this.data = x;
      this.calculateTotal();
    }, () => this.dialogRef.close())
  }

  calculateTotal() {
    this.total = {
      monthly: 0,
      quarterly: 0,
      yearly: 0,
      all: 0
    };

    this.data.forEach(product => {
      this.total.all += product.activeUsers;
      var monthly = product.plans.find(x => x.months === 1);
      var quarterly = product.plans.find(x => x.months === 3);
      var yearly = product.plans.find(x => x.months === 12);
      this.total.monthly += monthly ? monthly.activeUsers : 0;
      this.total.quarterly += quarterly ? quarterly.activeUsers : 0;
      this.total.yearly += yearly ? yearly.activeUsers : 0;
    })
  }

  search() {
    this.data = undefined
    this.total = undefined
    this.productStatsService.Get(this.dateUtc.set({ hours: 23, minute: 59, second: 59, millisecond: 999 }))
    .subscribe(x => {
      this.data = x;
      this.calculateTotal();
    }, () => this.dialogRef.close())
  }

  getActiveUsersByMonths(product: ProductStats, months: number) {
    const plan = product.plans.find(x => x.months === months);
    return  plan ? plan.activeUsers : '-';
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/components/scripts/productStatsModal.component.ts